import React, { Dispatch, SetStateAction } from "react";
import TitleSection from "../TitleSection/TitleSection";
import { IPwaProps } from "../../interfaces";
import "./styles.scss";
import { textsToTranslate } from "../../utils/translationServise";

interface IDescriptionModalProps extends IPwaProps {
  setIsDescriptionModalOpen: Dispatch<SetStateAction<boolean>>;
}

const Description = ({ pwa, setIsDescriptionModalOpen }: IDescriptionModalProps) => {
  const translations = pwa.translations || textsToTranslate;
  return (
    <div className="description-container">
      <TitleSection title={translations?.about} setIsDescriptionModalOpen={setIsDescriptionModalOpen} />
      <div className="description-content">
        <p className="description-text">{pwa.description}</p>
        <div className="description-category">
          {pwa.category.map((category, index) => (
            <span key={category + index} className="category-badge">
              {category}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Description;
